import {
  AsYouType,
  getCountries,
  getCountryCallingCode,
  isSupportedCountry,
  parsePhoneNumberFromString,
} from "libphonenumber-js/min";
import type { CountryCode } from "libphonenumber-js/min";
import { PHONE_INPUT } from "./phone-input.constants";

export function phoneCountry(value: string, preferred?: string): CountryCode {
  const candidate = preferred?.toUpperCase() as CountryCode;
  const fallback = isSupportedCountry(candidate)
    ? candidate
    : PHONE_INPUT.defaultCountry;
  const parsed = parsePhoneNumberFromString(value);
  return (
    parsed?.country ??
    (value.startsWith(`+${getCountryCallingCode(fallback)}`)
      ? fallback
      : (getCountries().find((country) =>
          value.startsWith(`+${getCountryCallingCode(country)}`),
        ) ?? fallback))
  );
}

export function nationalPhone(value: string, country: CountryCode): string {
  const prefix = `+${getCountryCallingCode(country)}`;
  return value.startsWith(prefix)
    ? value.slice(prefix.length)
    : value.replace(/\D/g, "");
}

export function internationalPhone(
  value: string,
  country: CountryCode,
): string {
  if (!value.trim()) return "";
  const formatter = new AsYouType(country);
  formatter.input(value);
  return formatter.getNumberValue() ?? "";
}

export function normalizePhoneInputValue(
  value: string,
  preferredCountry?: string,
): string {
  return internationalPhone(value, phoneCountry(value, preferredCountry));
}
